/**
 * Removes the static head tags the SPA re-renders. Called from the <SEO>
 * component's layout effect on its first commit.
 *
 * index.html (and every stamped copy build/generate-static-pages.js writes)
 * carries the page title, description, Open Graph, Twitter and canonical
 * tags twice over : once as static markup for a crawler that runs no
 * JavaScript, and once from the React <SEO> component once the page mounts.
 * React 19 places the component's tags in <head> as ordinary elements and
 * knows nothing of the static ones, so without this step a rendered page
 * carried two titles and two descriptions (reproduced 2026-09-14 on the
 * React 19 upgrade). It runs from the component rather than at boot so a
 * URL that renders no <SEO> keeps the static head. Every tag the component renders is marked
 * data-rh="true" in index.html ; the attribute name dates from
 * react-helmet-async, which reconciled by it until that upgrade and is gone,
 * and it stays because the stamper, the shell stripper and the head-contract
 * test all key on it. This removes exactly the marked set and leaves the
 * unmarked tags (author, viewport, the link-preview image set) in place,
 * because the component never renders those.
 * src/__tests__/components/SEO.test.js holds the contract that the marked
 * set and the rendered set are the same.
 *
 * @param {Document} doc - The document whose head is stripped.
 * @returns {number} How many marked tags were removed.
 */
export function removeStaticHeadTags(doc) {
  const marked = doc.head.querySelectorAll('[data-rh="true"]');
  marked.forEach((element) => element.remove());
  return marked.length;
}
